module.exports = __webpack_public_path__ + "img/time.9cfc2ffd.svg";